import React from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

const TwoColumnContent = (props) => {
  const { className, left, right, reverse } = props;

  return (
    <div className={classNames(styles.layout, reverse && styles.reverse, className)}>
      <div className={styles.left}>{left}</div>
      <div className={styles.right}>{right}</div>
    </div>
  );
};

export default TwoColumnContent;
